module.exports = __webpack_public_path__ + "static/img/nodata.303f52a1.png";